import { render, staticRenderFns } from "./svga-player.vue?vue&type=template&id=3d7177e4"
import script from "./svga-player.vue?vue&type=script&lang=js"
export * from "./svga-player.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports